import errors from './errors.js';
import translation from './translation/index.js';
const ptPT = Object.freeze({
    translation,
    errors,
});
export default ptPT;
